import { useEffect, useState } from 'react';

export default function HeroVestidosNovia() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-[75vh] min-h-[540px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=ethereal-bridal-haute-couture-gown-close-up-in-sunlit-minimalist-white-studio-ivory-silk-organza-lace-sheer-cape-delicate-pearl-embroidery-soft-warm-lighting-editorial-fashion-photography-golden-hour&width=1920&height=1080&seq=108&orientation=landscape"
          alt="Vestidos de novia alta costura Barcelona"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24 px-6 lg:px-[7%]">
        <div
          className={`transition-all duration-1000 ease-out ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="font-sans text-white/70 text-[11px] tracking-[0.2em] uppercase font-medium">
            Anthony Sánchez Couture — Barcelona
          </span>
          <h1 className="font-serif text-white text-[clamp(2.8rem,7vw,5.5rem)] font-light leading-[1.05] mt-4 max-w-4xl">
            Vestidos de Novia
            <span className="block italic font-light mt-1">a Medida</span>
          </h1>
          <p className="font-sans text-white/85 text-base md:text-lg max-w-xl leading-relaxed mt-6">
            Diseñamos y confeccionamos vestidos de novia únicos en nuestro atelier de Barcelona.
            Alta costura artesanal para el día más importante de tu vida.
          </p>
        </div>
      </div>
    </section>
  );
}